// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Crew Activities Data
 * Activity templates for crew life system
 */

export const ACTIVITY_TYPES = {
  SOCIAL: 'social',
  CONFLICT: 'conflict', 
  WORK: 'work',
  RECREATION: 'recreation',
  GROUP: 'group'
};

export const ACTIVITY_TEMPLATES = {
  [ACTIVITY_TYPES.SOCIAL]: [
    {
      id: 'chat_mess',
      name: 'Mess Hall Chat',
      description: '{crew1} and {crew2} share stories over a meal',
      relationshipChange: 5,
      moraleChange: 2,
      duration: 30,
      requirements: { location: ['ship', 'station'] }
    },
    {
      id: 'help_task',
      name: 'Helping Hand',
      description: '{crew1} helps {crew2} with their duties',
      relationshipChange: 8,
      moraleChange: 3,
      xpChange: 2,
      duration: 45,
      requirements: { location: ['ship'] }
    }
  ],

  [ACTIVITY_TYPES.CONFLICT]: [
    {
      id: 'argument',
      name: 'Heated Argument',
      description: '{crew1} and {crew2} have a disagreement about ship protocols',
      relationshipChange: -10,
      moraleChange: -5,
      duration: 20,
      requirements: { minRelationship: -20 }
    },
    {
      id: 'competition',
      name: 'Friendly Competition',
      description: '{crew1} challenges {crew2} to prove who\'s better',
      relationshipChange: -3,
      moraleChange: 1,
      xpChange: 1,
      duration: 25,
      requirements: { maxRelationship: 30 }
    }
  ],

  [ACTIVITY_TYPES.WORK]: [
    {
      id: 'maintenance',
      name: 'System Maintenance',
      description: '{crew1} performs routine maintenance on ship systems',
      moraleChange: -1,
      xpChange: 3,
      duration: 60,
      requirements: { location: ['ship'], roles: ['engineer', 'generic'] }
    },
    {
      id: 'training',
      name: 'Skills Training',
      description: '{crew1} practices their specialized skills',
      moraleChange: 2,
      xpChange: 5,
      duration: 90,
      requirements: { location: ['ship', 'station'] }
    }
  ],

  [ACTIVITY_TYPES.RECREATION]: [
    {
      id: 'holodeck',
      name: 'Holodeck Recreation',
      description: '{crew1} enjoys some downtime in the holodeck',
      moraleChange: 8,
      duration: 45,
      requirements: { location: ['ship'], modules: ['holodeck'] }
    },
    {
      id: 'reading',
      name: 'Personal Reading',
      description: '{crew1} reads in their quarters',
      moraleChange: 3,
      duration: 30,
      requirements: { location: ['ship'] }
    },
    {
      id: 'station_visit',
      name: 'Station Shore Leave',
      description: '{crew1} explores the station during shore leave',
      moraleChange: 10,
      duration: 120,
      requirements: { location: ['station'] }
    }
  ],

  [ACTIVITY_TYPES.GROUP]: [
    {
      id: 'team_meeting',
      name: 'Team Meeting',
      description: 'The crew gathers for a team meeting',
      moraleChange: 1,
      xpChange: 1,
      duration: 30,
      requirements: { location: ['ship'], minCrew: 3 },
      isGroup: true
    },
    {
      id: 'group_meal',
      name: 'Group Meal',
      description: 'The crew shares a meal together',
      relationshipChange: 2,
      moraleChange: 4,
      duration: 45,
      requirements: { location: ['ship', 'station'], minCrew: 2 },
      isGroup: true
    }
  ]
};

export const LOCATION_MODIFIERS = {
  ship: { moraleMultiplier: 1.0 },
  station: { moraleMultiplier: 1.2 },
  planet: { moraleMultiplier: 1.1 }
};